<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'lineChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        }
        // colorArr:{
        //     type: Array | Object,
        //     default: function () {
        //         let colr = 
        //         return colr;
        //     }
        // }
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        barOption(){
            let _this = this;
           
            let color= ["#08235d","#043298","#0d46c3","#145bdc","#3887d0","#66afe2"];
            _this.dataArray.nodes.forEach(node => {
                if(node.symbolSize == 100){
                    node.itemStyle = {
                        color: color[0]
                    };
                    node.label = {
                        align: 'center',
                        fontSize: 16
                    };
                }else if(node.symbolSize < 100 && node.symbolSize >= 90){
                    node.itemStyle = {
                        color: color[1]
                    };
                    node.label = {
                        align: 'center',
                        fontSize: 15
                    };
                }else if(node.symbolSize < 90 && node.symbolSize >= 80){
                    node.itemStyle = {
                        color: color[2]
                    };
                    node.label = {
                        align: 'center',
                        fontSize: 15
                    };
                }else if(node.symbolSize < 80 && node.symbolSize >= 70){
                    node.itemStyle = {
                        color: color[3]
                    };
                    node.label = {
                        align: 'center',
                        fontSize: 14
                    };
                }else if(node.symbolSize < 70 && node.symbolSize >= 60){
                    node.itemStyle = {
                        color: color[4]
                    };
                    node.label = {
                        align: 'center',
                        fontSize: 13
                    };
                }else{
                    node.itemStyle = {
                        color: color[5]
                    };
                }
            });
            _this.dataArray.links.forEach(link => {
                link.label = {
                    align: 'center',
                    fontSize: 12
                };
                link.lineStyle = {
                    color: '#666'
                }
            
            });
            
            var option = {
                legend: {
                    textStyle:{
                       color:'#fff' 
                    },
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {
                //             title: '下载',
                //         }
                //     }
                // },
                tooltip: {
                    formatter: function(param){
                            var newParams = param.data.labels;
                            if(param.data.posttime!=undefined){
                                newParams = param.data.labels + "<br/>" + param.data.posttime
                            }
                            return newParams;
                        }
                },
                series: [{
                    type: 'graph',
                    layout: 'force',
                    symbolSize: 58,
                    draggable: true,
                    roam: true,
                    focusNodeAdjacency: true,
                    edgeSymbol: ['', 'arrow'],
                    // edgeSymbolSize: [80, 10],
                    edgeLabel: {
                        normal: {
                            show: true,
                            textStyle: {
                                fontSize: 20
                            },
                            formatter(x) {
                                return x.data.name;
                            }
                        }
                    },
                    label: {
                        show: true,
                        lineHeight: 22,
                        formatter(x) {
                            let param = x.data.name;
                            param = param.replace(/[^\x00-\xff]/g,"$&\x01").replace(/.{8}\x01?/g,"$&\n").replace(/\x01/g,"");
                            return param;
                        }
                    },
                    force: {
                        repulsion: 2000,
                        edgeLength: 120
                    },
                    data: _this.dataArray.nodes,
                    links: _this.dataArray.links
                }]
            };
            return option;
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.barOption());
            _this.chart.on('mouseup', function (params) {
                var option = _this.chart.getOption();
                option.series[0].data[params.dataIndex].x = params.event.offsetX;
                option.series[0].data[params.dataIndex].y = params.event.offsetY;
                option.series[0].data[params.dataIndex].fixed = true;
                _this.chart.setOption(option);
            });
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/pathChart.vue